/* eslint-disable max-len */
/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthItem, clearAuthSession, broadcastLogout } from "../../CommonMethods/authSession";
// import userService from '../../services/user.services'

const user = getAuthItem('IdToken')
const initial = user ? true : false;

const initialState = {
    user: '',
    loading: true,
    initial_loading: false,
    error: '',
    success: '',
    access_token: '',
    email: '',
    loggedIn: initial,
}
export const loginUser = createAsyncThunk('user', async (body) => {
    // let res = await userService.login(body.email, body.password);
    // return res
})
const authSlice = createSlice({

    name: 'user',
    initialState,
    reducers: {
        addToken: (state, action) => {
            state.token = getAuthItem('token')
        },
        verifyOtp: (state, action) => {
            state.loggedIn = true
            state.email = action.payload
        },
        logIn:(state,action)=>{
            state.loggedIn=true
            state.email=action.payload
        },
        setUserType: (state, action) => {
            
            state.userType = action.payload

        
            state.initial_loading=false

        },
       
        logout: (state, action) => {
            clearAuthSession()
            broadcastLogout();
            state.loggedIn = false
            state.email = '';
            state.userType=''
        },
      
       
        
    },
    
})
export const { addToken, verifyOtp,logIn,logout,setUserType } = authSlice.actions;
export default authSlice.reducer